module.exports = __webpack_public_path__ + "static/media/qr-code-example.624fc1bb.svg";